
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqf8eLRPQycFrcdnOJwgi3GS9fESYQuDAG9BFXLhOCX24Meta } from "/codebuild/output/src330911042/src/src/pages/faq.vue?macro=true";
import { default as menutvjwXkC8vNh_45NelvkpxgWLlft9JRfxyMag_45YhhTw0RMMeta } from "/codebuild/output/src330911042/src/src/pages/menu.vue?macro=true";
import { default as indexN77BxV8okz0YCMbrfdZeCVW8_4563G_fcQ2aiugUSJ0P8Meta } from "/codebuild/output/src330911042/src/src/pages/index.vue?macro=true";
import { default as contactyKnZHyj05yLYAejTwWn3QJCTKvO6iAIT8UPTIU7iE0AMeta } from "/codebuild/output/src330911042/src/src/pages/contact.vue?macro=true";
import { default as tutorialWH85V7Vnseuga8LlczNBMRZaknLjiAw9BHOX_45RmwslwMeta } from "/codebuild/output/src330911042/src/src/pages/tutorial.vue?macro=true";
import { default as agreementx_VYInS2OBt8uDCtPKDRUp5lTs6uZPSmuRJk6FBRGosMeta } from "/codebuild/output/src330911042/src/src/pages/agreement.vue?macro=true";
import { default as about_45pass5TGLFeLNfgDbeumEEmHm0KVGryFpwW679NFzOY83CI8Meta } from "/codebuild/output/src330911042/src/src/pages/about-pass.vue?macro=true";
import { default as index8SzA9Ba0N5CMgZflWyx4dKVa7sqcr39nO4iXRwx0DRkMeta } from "/codebuild/output/src330911042/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93AK_45zcQb8Kmh4MFd2oVEIq3ZqJCTBwpSGSjBUyYRL7awMeta } from "/codebuild/output/src330911042/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceWbiaYX_45YD3kFYo0E_UXtlizdkOzfgJrAZ41NilvQ6RwMeta } from "/codebuild/output/src330911042/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93_45gMQQdo7hpI1O66C8vuol5ZZyZgwJfzKlmuAEdMoSWAMeta } from "/codebuild/output/src330911042/src/src/pages/notice/[id].vue?macro=true";
import { default as index3PAg_i24nXSz48UGJCWwcM0y611RzRbf0FJLxFDzKKoMeta } from "/codebuild/output/src330911042/src/src/pages/coupon/index.vue?macro=true";
import { default as indexWcKMay_45uEuFhhuys2pNa_3myWq_5D42IdXbnGw8d9XEMeta } from "/codebuild/output/src330911042/src/src/pages/mypage/index.vue?macro=true";
import { default as indexTgwtpOwxu0QTG8Mm9NhcAMQtHhr2u3GOloRGrHdXBt4Meta } from "/codebuild/output/src330911042/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_937vqo_mmUOrcHgu_VxovHAecdRXKMiuXz3JFuiHl0S2YMeta } from "/codebuild/output/src330911042/src/src/pages/parking/[id].vue?macro=true";
import { default as indexnUXp6XrLp4y3dQVoaWuKhwrJqQsct1cLNwrjkumS2McMeta } from "/codebuild/output/src330911042/src/src/pages/history/index.vue?macro=true";
import { default as indexTQhALc4zyh53po_45WSVwlshVzzoyrEW10xRo6KjAye7AMeta } from "/codebuild/output/src330911042/src/src/pages/monthly/index.vue?macro=true";
import { default as indexYX_455WiiUdQOuaysBqRVwE5CKe0AkWlPwg8xD_452ici5cMeta } from "/codebuild/output/src330911042/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexm0IXJkWYV2QowT1dp1a9cFJrlSMX6vjKGhiqwVWgTvsMeta } from "/codebuild/output/src330911042/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviPsn8D8fCkZElOaw306MOUxMmI4dNhX0mUYgrQ28TG90Meta } from "/codebuild/output/src330911042/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit04YtQAlUtm1U5Oq3dcwMMt3rJr_Xp3mckILWWu8gs18Meta } from "/codebuild/output/src330911042/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementatupYJmxXSAlLsWtKb14UZiyLlqvUyGMZABHFaAxQX4Meta } from "/codebuild/output/src330911042/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexK9aYUAj_F1JQ0LJabqkKZyQvceImhG6IuqjdMbiiCNEMeta } from "/codebuild/output/src330911042/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453ds_45MrrRgwTLcPVZyAZi0SG2_sn59UemiDDTSfE5oKGYEMeta } from "/codebuild/output/src330911042/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirm5M0s3xp0uxKo2_45vKuQzCqt_45xMVxXEZnEYiwaLWtXED8Meta } from "/codebuild/output/src330911042/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as index3Mp3OYdpKiv4kag3NxKSUIeZ1Wdr2Ee_BJIkHZADXmIMeta } from "/codebuild/output/src330911042/src/src/pages/card/create/index.vue?macro=true";
import { default as indexrxPyF42ynnTblcdY7zfLFtaxE_45qgjUqFumDg1WluKxIMeta } from "/codebuild/output/src330911042/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmLEs7Y6G_FkCfIybuiLK21WXfbvNDJwBzI6CmP33c1jkMeta } from "/codebuild/output/src330911042/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmWbk8YL1muksHHJJwQcutLdtK76dSgBsxtOQvTiEo5CAMeta } from "/codebuild/output/src330911042/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete8xRfMstMbtJNtjt_45NAAAjUQh0L5mimRNmwJnW368EuMMeta } from "/codebuild/output/src330911042/src/src/pages/membership/complete.vue?macro=true";
import { default as registerNVIEO9dZ0qUF6jEOZbHgcTbmxwFHlw22B9ihDvOg6oQMeta } from "/codebuild/output/src330911042/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93ZanTcUm2dF0O553Hz_BdFckgp8gq6eLZPsdblvZOF6QMeta } from "/codebuild/output/src330911042/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmpY5630YNDDIn21wHMtv0YYJAu_TVC0cWF3zX2QaaL3gMeta } from "/codebuild/output/src330911042/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93YHUTk2nXoC1g6aE6dLeryCG9sd_45Juv_45yi20qhc5b688Meta } from "/codebuild/output/src330911042/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexGuBn_FeRTpZ81dAOkGUmEU3mMgietWII4hffK52faFMMeta } from "/codebuild/output/src330911042/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeThmCnhmFqjrOzdB7rZn8vrTYnMD_4yqQP4wut_45o6I34Meta } from "/codebuild/output/src330911042/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45code9UZXDKFZTsGkPwMX7PDFa7CNZoks_dRptaBV1qhnlbgMeta } from "/codebuild/output/src330911042/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as complete3DUAIO_45Rl6fDX3R6o8g7owmdYRwZpsI8U_p3lPaf3pQMeta } from "/codebuild/output/src330911042/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registervhtDD2KHX6YDpvXTNPTrhRCj9y0fhJM3Cd4128wF94wMeta } from "/codebuild/output/src330911042/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeoCraaYwOOaLRfy_45NGHwNOq0dfoVllG2dnZ4_45E9r6w1kMeta } from "/codebuild/output/src330911042/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexTCWtnM_S_Rx3J0vozH9DIl5chSZOsjIWSaUIu4t4RccMeta } from "/codebuild/output/src330911042/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmaVlVRZPe9aLRnw4o1va_45edRuJXyqG_hif9qU1uoKE7oMeta } from "/codebuild/output/src330911042/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completebx7h8yw6ANlMIcHridJsyv7UhFmzKgJZZkwuUfAYSY4Meta } from "/codebuild/output/src330911042/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexz8YhdCYWR9_459T589uuUot8E87ZCc8tCTTfZkKuNF53oMeta } from "/codebuild/output/src330911042/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_933u6MpNr3w9i2xQjDM5aWPo8Iu83pXM_gcORuvCZV6IUMeta } from "/codebuild/output/src330911042/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as complete9f5fPueQFuscgRV0IKhWOiB2SxaSAom92tMF589dK0QMeta } from "/codebuild/output/src330911042/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45alias5jQFdUaISRDxKBCpWr_07BXyDRBtP8LM_45_456tNHdqd9oMeta } from "/codebuild/output/src330911042/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleh4PYqv5kJFP5qKm_QFdoPytVo0HBB7oqi7qgpYsYXykMeta } from "/codebuild/output/src330911042/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailPeQ3QBoxze7DIa_pnOZm7ORNgQL2YLp81GbYC0RwgosMeta } from "/codebuild/output/src330911042/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmjWNgcJUZ9Vr5gGPPRqAXoB9NizGekUK6EWro0_GEhIIMeta } from "/codebuild/output/src330911042/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentrzz7NajV5vQx9B9pmWZsMCWyyIvBoaoUx3SbT48_45ac4Meta } from "/codebuild/output/src330911042/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmRo8f0t2mrn_45W47iDZ8PDPe3eD_Hbr8tGQMrO7USe0aAMeta } from "/codebuild/output/src330911042/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateG6G8PxqhhqEU8H9F8CheClbGuksPImxg059IKcALJqUMeta } from "/codebuild/output/src330911042/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completepbObcEM3EgkkvK6z_iQh3KPlg9gqgCGuwRbP1wSRP_YMeta } from "/codebuild/output/src330911042/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeubeyJQ61tMv5vXWKsmqgD_45qnG_45ju4GgcsDedzzGpLKIMeta } from "/codebuild/output/src330911042/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordJC7XrlI1NymWjMpXiDYwCZ_45YwL2SZid903c03Q7_45ENYMeta } from "/codebuild/output/src330911042/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasW_45aruNRkf5RfclM1eroUdbtNdC_B6cKTq6WCNi9YQQAMeta } from "/codebuild/output/src330911042/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registertTjHOQbirhH5KHHje1jkGr2QDj3GNoXT4_45V5c__45_NeEMeta } from "/codebuild/output/src330911042/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeUmW760ezYgexnWtiiBj35renwklv7dYhh7PGXg3Q6U8Meta } from "/codebuild/output/src330911042/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexSvjvxPfG1J69duPDp6lmFQhXjVHcuAeSKlU9fL0oHaYMeta } from "/codebuild/output/src330911042/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexJDPNmTeP26FEYR4Cl_DXGEYfjHCR6i2piNHDGcpWGE0Meta } from "/codebuild/output/src330911042/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexutrw3ALMNuMgQtRVtAoVel46b_7iblQjX1xS2kLJhzIMeta } from "/codebuild/output/src330911042/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indextyWBNFyLU8ubFCoxb5N2ezXEneWNaY97_45MddwGuAUqUMeta } from "/codebuild/output/src330911042/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateA8WKZKZPcz_45TTL9Qc9iWaPRo5oEdfih5bmYkOI_45MIw0Meta } from "/codebuild/output/src330911042/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completecMLjCKgbphsWXMIEr8Ol5vZuGAruCvs7_sAMssbm_458kMeta } from "/codebuild/output/src330911042/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirm75llLCCSUEkpBM0F1gGLsz61b5h6EaHyDATnAoohWc4Meta } from "/codebuild/output/src330911042/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexEPRljotgOY4gby_ESn6UgRzUV7McH4rFjrasgAADP7sMeta } from "/codebuild/output/src330911042/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeqPI9CFpRlUbftblrp_45BknTgzjrpqPWhAkpkdrTZhjRUMeta } from "/codebuild/output/src330911042/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updatep_45XTGRSVasoMSNIp0SFUhdTc0KNzoNB2qx9FNi4S_45qoMeta } from "/codebuild/output/src330911042/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexvVhYLBvjiFkNsdT7jZZ6_453veFh9WRLb7rXcSJoq6cS4Meta } from "/codebuild/output/src330911042/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as index_5KHDzNvZ95NoMR2_TyKH_zHL9x3bC_SSHXhMUnL03MMeta } from "/codebuild/output/src330911042/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as complete2aFSd0nt1QUXIjelDT9znWAYMOmifx5h8SRRh1Lg8yoMeta } from "/codebuild/output/src330911042/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexH3vVIEms1mNdDa5CxIZLN9jHY0HwbkiWPfbsIW8U_45A4Meta } from "/codebuild/output/src330911042/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45code93rd5ytJI68S_vlNdbojWCMGnXWFpPLK2Yq2ECYum9YMeta } from "/codebuild/output/src330911042/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexWxvNSj7qiT5nCeCKcIBkEK7OK7fk286dhL7yuR_9KewMeta } from "/codebuild/output/src330911042/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexpI_45s5JRo3W7cgfqmkZ431VNZpYseBxUYPhfr2p76MOYMeta } from "/codebuild/output/src330911042/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexRwK5xKNRNcdqwO6yRSPS23t6GQPbs_qCG3JSOPNYPpUMeta } from "/codebuild/output/src330911042/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatefH1latk2LlvZPQRVDJarL9V1_x_wbEarembj6EFV3YAMeta } from "/codebuild/output/src330911042/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirm_fTUtu3La9IkhLjZUAYaCQf62o5QRltmZofJrxZiUMYMeta } from "/codebuild/output/src330911042/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src330911042/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menutvjwXkC8vNh_45NelvkpxgWLlft9JRfxyMag_45YhhTw0RMMeta || {},
    component: () => import("/codebuild/output/src330911042/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexN77BxV8okz0YCMbrfdZeCVW8_4563G_fcQ2aiugUSJ0P8Meta || {},
    component: () => import("/codebuild/output/src330911042/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src330911042/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src330911042/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src330911042/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src330911042/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src330911042/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src330911042/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src330911042/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src330911042/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(index3PAg_i24nXSz48UGJCWwcM0y611RzRbf0FJLxFDzKKoMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src330911042/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src330911042/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src330911042/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src330911042/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexnUXp6XrLp4y3dQVoaWuKhwrJqQsct1cLNwrjkumS2McMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src330911042/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src330911042/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexYX_455WiiUdQOuaysBqRVwE5CKe0AkWlPwg8xD_452ici5cMeta || {},
    component: () => import("/codebuild/output/src330911042/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexm0IXJkWYV2QowT1dp1a9cFJrlSMX6vjKGhiqwVWgTvsMeta || {},
    component: () => import("/codebuild/output/src330911042/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src330911042/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src330911042/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src330911042/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src330911042/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src330911042/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src330911042/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: index3Mp3OYdpKiv4kag3NxKSUIeZ1Wdr2Ee_BJIkHZADXmIMeta || {},
    component: () => import("/codebuild/output/src330911042/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src330911042/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmLEs7Y6G_FkCfIybuiLK21WXfbvNDJwBzI6CmP33c1jkMeta || {},
    component: () => import("/codebuild/output/src330911042/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmWbk8YL1muksHHJJwQcutLdtK76dSgBsxtOQvTiEo5CAMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src330911042/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete8xRfMstMbtJNtjt_45NAAAjUQh0L5mimRNmwJnW368EuMMeta || {},
    component: () => import("/codebuild/output/src330911042/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerNVIEO9dZ0qUF6jEOZbHgcTbmxwFHlw22B9ihDvOg6oQMeta || {},
    component: () => import("/codebuild/output/src330911042/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src330911042/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmpY5630YNDDIn21wHMtv0YYJAu_TVC0cWF3zX2QaaL3gMeta || {},
    component: () => import("/codebuild/output/src330911042/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src330911042/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src330911042/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeThmCnhmFqjrOzdB7rZn8vrTYnMD_4yqQP4wut_45o6I34Meta || {},
    component: () => import("/codebuild/output/src330911042/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45code9UZXDKFZTsGkPwMX7PDFa7CNZoks_dRptaBV1qhnlbgMeta || {},
    component: () => import("/codebuild/output/src330911042/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: complete3DUAIO_45Rl6fDX3R6o8g7owmdYRwZpsI8U_p3lPaf3pQMeta || {},
    component: () => import("/codebuild/output/src330911042/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registervhtDD2KHX6YDpvXTNPTrhRCj9y0fhJM3Cd4128wF94wMeta || {},
    component: () => import("/codebuild/output/src330911042/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src330911042/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src330911042/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmaVlVRZPe9aLRnw4o1va_45edRuJXyqG_hif9qU1uoKE7oMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src330911042/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completebx7h8yw6ANlMIcHridJsyv7UhFmzKgJZZkwuUfAYSY4Meta || {},
    component: () => import("/codebuild/output/src330911042/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexz8YhdCYWR9_459T589uuUot8E87ZCc8tCTTfZkKuNF53oMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src330911042/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src330911042/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: complete9f5fPueQFuscgRV0IKhWOiB2SxaSAom92tMF589dK0QMeta || {},
    component: () => import("/codebuild/output/src330911042/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src330911042/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleh4PYqv5kJFP5qKm_QFdoPytVo0HBB7oqi7qgpYsYXykMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src330911042/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailPeQ3QBoxze7DIa_pnOZm7ORNgQL2YLp81GbYC0RwgosMeta || {},
    component: () => import("/codebuild/output/src330911042/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmjWNgcJUZ9Vr5gGPPRqAXoB9NizGekUK6EWro0_GEhIIMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src330911042/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentrzz7NajV5vQx9B9pmWZsMCWyyIvBoaoUx3SbT48_45ac4Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src330911042/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmRo8f0t2mrn_45W47iDZ8PDPe3eD_Hbr8tGQMrO7USe0aAMeta || {},
    component: () => import("/codebuild/output/src330911042/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src330911042/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completepbObcEM3EgkkvK6z_iQh3KPlg9gqgCGuwRbP1wSRP_YMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src330911042/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeubeyJQ61tMv5vXWKsmqgD_45qnG_45ju4GgcsDedzzGpLKIMeta || {},
    component: () => import("/codebuild/output/src330911042/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordJC7XrlI1NymWjMpXiDYwCZ_45YwL2SZid903c03Q7_45ENYMeta || {},
    component: () => import("/codebuild/output/src330911042/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src330911042/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registertTjHOQbirhH5KHHje1jkGr2QDj3GNoXT4_45V5c__45_NeEMeta || {},
    component: () => import("/codebuild/output/src330911042/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeUmW760ezYgexnWtiiBj35renwklv7dYhh7PGXg3Q6U8Meta || {},
    component: () => import("/codebuild/output/src330911042/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src330911042/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src330911042/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src330911042/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src330911042/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src330911042/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src330911042/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src330911042/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src330911042/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src330911042/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src330911042/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src330911042/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src330911042/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src330911042/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src330911042/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src330911042/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src330911042/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src330911042/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src330911042/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src330911042/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src330911042/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]